<title mat-dialog-title>{{ 'communication.chat.addNotesPrompt' | t }}</title>
<mat-dialog-content>
  <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="danger" mat-dialog-close>{{ 'common.no' | t }}</button>
  <button mat-button color="success" [disabled]="form.invalid" (click)="send()">{{ 'common.send' | t }}</button>
</mat-dialog-actions>
